import type { ReactNode } from 'react'

interface EmptyStateProps {
  icon?: string
  heading: string
  message?: string
  action?: ReactNode
}

export function EmptyState({ icon = 'ri-inbox-line', heading, message, action }: EmptyStateProps) {
  return (
    <div className="p-5 text-center">
      <span className="avatar avatar-xl avatar-rounded bg-secondary-transparent">
        <i className={`${icon} fs-2`} />
      </span>
      <h6 className="fw-medium mt-3">{heading}</h6>
      {message && <p className="text-muted fs-13 mb-3">{message}</p>}
      {action}
    </div>
  )
}
